import React, {useRef} from 'react';
import styled, {css} from 'styled-components';

import {StyledBody, StyledHeader, StyledLabel, StyledTable} from './shared';
import {SubjectCell, CellText, CellSecondary, iconMap} from '@bootcamp/web/src/bootcamps/components/Performance/shared';
import {TableOverflowOuterWrapper, TableOverflowInnerWrapper, DivergentBar, CellIcon} from '@bootcamp/web/src/bootcamps/components/Performance/shared';
import {AutoHeightParent} from '@bootcamp/web/src/components/AutoHeightParent';

import {useUserDataContext} from '@bootcamp/web/src/contexts/UserData';
import {averages, averagesWithPlusTests} from './averages';

import {formatTimeSpent} from '@bootcamp/shared/src/util';


const Container = styled.div`
  border-radius: 8px;
`;
const SubjectTable = styled(StyledTable)`
  td {
    min-width: 160px;
  }

  tr:first-child {
    td {
      width: 100%;
      white-space: nowrap;
    }
  }

  td:last-child {
    text-align: left;
  }
`;
const SubjectHeader = styled(StyledHeader)`
`;

export const TimeManagement = ({dataBySubject=[], subjectFilter=null, expandAll=false, parentHasPadding, subjectTopicCounts, mastery, subjectAverages}) => {
  const {isBootcampPlusStudent} = useUserDataContext();
  const tableWrapperRef = useRef(null);

  const averagesObj = isBootcampPlusStudent ? averagesWithPlusTests : averages;

  const rows = Object
    .keys(averagesObj)
    .filter(key => subjectFilter ? subjectFilter?.includes(key) : true)
    ?.map(subject => {
      const correspondingSubject = dataBySubject.find(({testSubject}) => testSubject === subject);
      const timePerQuestion = correspondingSubject?.timeSpent / correspondingSubject?.total;
      const avgTime = averagesObj[subject]?.avgTime / averagesObj[subject]?.totalQuestions;

      return {
        cells: [
          {content: (
            <SubjectCell>
              <CellIcon src={iconMap?.dat?.[subject]}/>
              <CellText>{subject}</CellText>
            </SubjectCell>
          )},
          {content: formatTimeSpent(timePerQuestion)},
          {content: (
            <CellSecondary>{formatTimeSpent(avgTime)}</CellSecondary>
          )},
          {content: (
            <DivergentBar
              reference={avgTime}
              value={timePerQuestion}
              height={16}
              dividerWidth={1.5}
              />
          )}
        ]
      };
    });

  return (
    <Container>
      <SubjectHeader parentHasPadding={parentHasPadding}>
        <StyledLabel>Time Management</StyledLabel>
        <StyledBody>Green means you're faster than average! Red shows where you can improve your pace.</StyledBody>
        {/* <StyledBlurb icon={ari} text={<span >Topics marked with a red <Info style={{verticalAlign: -3}} size={16} color="#E05E57" /> should receive additional attention.</span>} lightMode/> */}
      </SubjectHeader>
      <AutoHeightParent childRef={tableWrapperRef}>
        <TableOverflowOuterWrapper parentHasPadding={parentHasPadding}>
          <TableOverflowInnerWrapper ref={tableWrapperRef} parentHasPadding={parentHasPadding}>
            <SubjectTable
              expandAll={expandAll}
              hideChevrons
              hideLastCell
              fixed={false}
              rows={[
                { cells: [{ content: 'Subject' }, { content: 'Time Per Question' }, {content: 'Avg. Time', disabled: true}, {content: 'Pace'}] },
                // {cells: [{content: ''}, {content: 'Total'}, {content: ''}, {content: `${Math.round(totalsAcrossSubjects.correct / (totalsAcrossSubjects.total || 1) * 100)}%`}, {content: `${totalsAcrossSubjects.correct} / ${totalsAcrossSubjects.total}` }, { content: '' }] },
                ...rows
              ]}
            />
          </TableOverflowInnerWrapper>
        </TableOverflowOuterWrapper>
      </AutoHeightParent>
    </Container>
  );
};
